import { AppId } from '@shared/types'

const DEFAULT_SESSION_TTL_MINUTES = 60

export const DEFAULT_SESSION_TTL_SECONDS = DEFAULT_SESSION_TTL_MINUTES * 60

export class SessionTimeoutConfig {
  readonly sessionLimitInSeconds: number
  readonly sessionLimitInMs: number
  readonly showTimeoutModalInMs: number

  constructor(
    readonly sessionLimitInMinutes: number = DEFAULT_SESSION_TTL_MINUTES,
    readonly showReminderBeforeLogoutMinutes: number = 5,
  ) {
    this.sessionLimitInSeconds = sessionLimitInMinutes * 60
    this.sessionLimitInMs = sessionLimitInMinutes * 60 * 1000
    this.showTimeoutModalInMs = (sessionLimitInMinutes - showReminderBeforeLogoutMinutes) * 60 * 1000
  }
}

export const sessionTimeoutConfigs: Record<AppId, SessionTimeoutConfig> = {
  [AppId.DigiLi]: new SessionTimeoutConfig(),
  [AppId.CreditCard]: new SessionTimeoutConfig(),
  [AppId.Kyc]: new SessionTimeoutConfig(),
  [AppId.Bcr]: new SessionTimeoutConfig(10, 3),
  [AppId.SecLoans]: new SessionTimeoutConfig(90),
  [AppId.CorpKyc]: new SessionTimeoutConfig(90),
  [AppId.DigiLa]: new SessionTimeoutConfig(),
  [AppId.SelfService]: new SessionTimeoutConfig(),
  [AppId.BankAccounts]: new SessionTimeoutConfig(),
}
